import _color from './color'
import _icon from './icon'
import _image from './image'

export const color = _color
export const icon = _icon
export const image = _image
